import { STORAGE_KEYS } from "@/constants/storage"
import { isIOS } from "@/utils"
import { create } from "zustand"
import env from "@/env"
import useChannelStore from "./channel"

const useGlobalStore = create<{
  // token: string
  // setToken: (token: string) => void

  // userInfo:any
  // setUserInfo: (channelCode: string) => void

  coOperationType: string
  setCoOperationType: (coOperationType: string) => void
  getDownloadUrl: () => string
}>((set, get) => ({

  // token: localStorage.getItem(STORAGE_KEYS.TOKEN) || '',
  
  // setToken: (token: string) => set({ token }),

  // userInfo:localStorage.getItem(STORAGE_KEYS.USERINFO)?JSON.parse(localStorage.getItem(STORAGE_KEYS.USERINFO) as string):{},
  // setUserInfo: (userInfo) => {
  //   set({ userInfo })
  //   localStorage.setItem(STORAGE_KEYS.USERINFO,JSON.stringify(userInfo))
  // },

  coOperationType: localStorage.getItem(STORAGE_KEYS.CO_OPERATION_TYPE) || '',
  setCoOperationType: (coOperationType: string) => set({ coOperationType }),

  getDownloadUrl: () => {
    if (isIOS()) {
      return env.goEasyIosApkUrl
    }

    const CHANNEL_MAP = {
      YOU_QIAN_QIAN_BAO: 'No61PP', // 有钱钱包
      RONG_YI_HUA: 'otvD8f', // 融逸花
    }
    const channelCode = useChannelStore.getState().channelCode
    if (channelCode === CHANNEL_MAP.YOU_QIAN_QIAN_BAO) {
      return env.goEasyYouqianqianbaoApkUrl
    }
    if (channelCode === CHANNEL_MAP.RONG_YI_HUA) {
      return env.goEasyRongyihuaApkUrl
    }
    return env.goEasyCommonApkUrl
  },
  
}))

export default useGlobalStore